module.exports = "pegasus_template/assets/gray-large-linkedin.png";